import { Card, CardCaption, CardContainer, getSpacing, HorizontalLine, ButtonBase, ButtonBaseProps } from '@rahtab/ui';
import { Load, LoadStatusCode } from 'hooks/useVetApproveHistory';
import React from 'react';
import { StyleSheet, View } from 'react-native';
import { fixDateTime, withSeparator } from '../tools/string';
import ItemStatusTag from './ItemStatusTag';
import LabeledText from './LabeledText';

interface LoadItemCardProps extends Load, Pick<ButtonBaseProps, 'screenName' | 'params'> {
  extended?: boolean;
}

const LoadItemCard: React.VFC<LoadItemCardProps> = (props) => {
  const {
    StatusCode: statusCode,
    StatusText: status,
    approveAmount,
    approveDate,
    assignDate,
    assignerCode,
    assignerName: assigner,
    deliveryDate,
    receiveDate,
    registerDate,
    reqAmount: assignAmount,
    reqDate,
    reqIdentification,
    reqMeasure: unit,
    requestCode,
    supplierCode,
    supplierName: supplier,
    extended = false,
    screenName,
    params,
  } = props;
  const isApproved = statusCode === LoadStatusCode.Approved;
  const isPending = statusCode === LoadStatusCode.Pending;
  const isExpired = statusCode === LoadStatusCode.Expired;
  const isReported = statusCode === LoadStatusCode.Reported;

  const purchaseOrderId = reqIdentification || requestCode;
  const submitDate = approveDate || receiveDate;
  const amount = approveAmount || assignAmount;

  return (
    <Card style={StyleSheet.flatten([styles.card, extended && { marginVertical: getSpacing() }])}>
      <ButtonBase screenName={screenName} params={params} disabled={extended}>
        <CardContainer>
          <View style={styles.rowView}>
            <LabeledText label="شناسه سفارش" color="primary" children={purchaseOrderId} />
            <ItemStatusTag code={statusCode} text={status} />
          </View>
          <LabeledText label="تخصیص دهنده" margin={extended ? 'default' : 'none'} children={assigner} />
          {extended && (
            <>
              <LabeledText label="منبع تامین" children={supplier} />
              {!isReported && (
                <>
                  {!isExpired && (
                    <LabeledText label="مقدار تخصیص شده" children={withSeparator(assignAmount) + ' ' + unit} />
                  )}
                  <LabeledText label="تاریخ تحویل" margin={!isExpired ? 'default' : 'none'} children={deliveryDate} />
                </>
              )}
              {!isExpired && (
                <>
                  <HorizontalLine />
                  <LabeledText
                    label={isApproved ? 'مقدار بار ورودی تایید شده' : 'مقدار بار ورودی'}
                    margin="none"
                    children={withSeparator(amount) + ' ' + unit}
                  />
                </>
              )}
            </>
          )}
        </CardContainer>
        {!isPending && !isExpired && (
          <CardCaption>
            <LabeledText
              label={isReported ? ' زمان ثبت گزارش' : 'زمان تایید'}
              margin="none"
              children={fixDateTime(submitDate)}
            />
          </CardCaption>
        )}
      </ButtonBase>
    </Card>
  );
};

export default LoadItemCard;

const styles = StyleSheet.create({
  card: {
    marginVertical: getSpacing(0.5),
    marginHorizontal: getSpacing(1),
  },
  rowView: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
  },
});
